import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  TextField,
  FormControl,
  Box,
  DialogContentText,
} from '@mui/material';
import { useState } from 'react';
import { useConfirm } from 'material-ui-confirm';
import { CloseTwoTone, SaveAltTwoTone, SaveTwoTone } from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConcluirProducao = ({
  openDialogConcluirProducao,
  onClose,
  producaoSelecionada,
  concluirProducao,
  qtdeCaixasProducaoSelecionada,
}) => {
  const [qtde, setQtde] = useState('');
  const [volume, setVolume] = useState('');
  const [palete, setPalete] = useState('');

  const confirm = useConfirm();

  const verificaQuantidade = () => {
    if (
      qtde >= qtdeCaixasProducaoSelecionada * 1.1 ||
      qtde <= qtdeCaixasProducaoSelecionada * 0.9
    ) {
      confirm({
        title: 'ATENÇÃO NA QUANTIDADE !',
        description:
          'A quantidade de caixas DIGITADA é superior ou inferior quantidade da ordem de produção. Verifique!',
      })
        .then(() => {})
        .catch(() => {
          /* ... */
        });
    }
  };
  return (
    <Dialog
      open={openDialogConcluirProducao}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>FINALIZA A PRODUÇÃO</DialogTitle>
      <DialogContent dividers>
        <DialogContent dividers>
          <DialogContentText>
            DIGITE A QUANTIDADE DE CAIXAS PRODUZIDAS NA ORDEM :
            {producaoSelecionada}
          </DialogContentText>
        </DialogContent>
        <DialogContent></DialogContent>

        <Box mt={2} mb={2}>
          <FormControl fullWidth>
            <TextField
              label="QUANTIDADE "
              type="number"
              value={qtde}
              onBlur={verificaQuantidade}
              onChange={(e) => setQtde(e.target.value)}
            />
          </FormControl>
        </Box>
        <Box mt={2} mb={2}>
          <FormControl fullWidth>
            <TextField
              label="VOLUMES "
              type="number"
              value={volume}
              onChange={(e) => setVolume(e.target.value)}
            />
          </FormControl>
        </Box>
        <Box mt={2} mb={2}>
          <FormControl fullWidth>
            <TextField
              label="PALETES "
              type="number"
              value={palete}
              onChange={(e) => setPalete(e.target.value)}
            />
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-around' }}>
        <Button
          variant="contained"
          startIcon={<CloseTwoTone />}
          onClick={onClose}
        >
          Fechar
        </Button>
        <Button
          variant="contained"
          startIcon={<SaveTwoTone />}
          onClick={() => {
            concluirProducao(producaoSelecionada, qtde, volume, palete);
          }}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConcluirProducao;
